import React, { useEffect, useState } from 'react'
import { Collapsible, ThemeProvider } from '@workboard/wobo-ui'
import { HtmlContent } from '@workboard/ui-okr'
import styled from 'styled-components'
import CustomAtrservice from '../services/CustomAtr.service'
import { useTranslation } from 'react-i18next';
import { FieldTypeAttributes } from '../utils/constants'
import { normalizeStoredValueToHtml } from '../utils/normalizeStoredValueToHtml'
import '../scss/okr-customField.scss'
const StyledCollapsible = styled(Collapsible)`
  background: #ffffff;
  border: 1px solid #c4cbd7;
  border-radius: 8px;
  padding: 0px 10px;
  overflow: hidden;

  .sc-xGAEC {
    font-weight: 700;
    font-size: 14px;
  }
  .HCbWs {
    padding-top: 0px;
    margin-top: 10px;
    border-top: none;
    overflow: hidden !important ;
  }
  .gJeMhs{
    border-top: none !important;
  }
`

// getCustomFieldsByObject
const CustomAtrServices = new CustomAtrservice()

const CustomField = (props) => {
  const [results, setResults] = useState([]);
  const {t} = useTranslation();
  useEffect(() => {
    const params = {
      objectId: props.objId,
      objectType: props.objTyp
    }

    CustomAtrServices.getCustomFieldsByObject(params).then((res) => {
      let temp = res.data.data;
      setResults([...results, ...temp ])
    }).catch((err) => {
      console.log(err)
    })
  }, [])
  return (
    <ThemeProvider>
      <div className="custumAttribute" style={{ padding: `${props.padding}` }}>
        <div className="custom-header">{t('Custom fields')}</div>
        {results.length > 0 ? results.map((item, i) => (
          <div className="custom-Pannel">
            <StyledCollapsible
              title={item.group_category_name}
              open={i == 0 ? true : false}
            >
              <div className="custom-content">
                {item && item.custom_fields != null && item.custom_fields.map((list) => (
                  <div className='wrap-text'>
                    <span className="label">{list.name}:</span>
                    {Number(list.field_type_id) === FieldTypeAttributes.ATTRIBUTE_TEXT_AREA ? (
                      <div className="content-richtext">
                        <HtmlContent htmlContent={normalizeStoredValueToHtml(list.customValue)} component="div" />
                      </div>
                    ) : (
                      <span className="content">{list.customValue}</span>
                    )}
                  </div>
                ))}
              </div>
            </StyledCollapsible>
          </div>
        )) : "" }
      </div>
    </ThemeProvider>
  )
}

export default CustomField
